/*
SaiKrishna 10/06/2022 2698403495 Removed unnecessary console.log statements
*/
const {
  REACT_APP_API_END_POINT,
  REACT_APP_API_PORT,
  REACT_APP_API_LABEL,
  REACT_APP_API_VERSION,
  REACT_APP_SSL_ENABLED,
  REACT_APP_GA_MEASUREMENT_ID,
} = process.env;
const config = {
  default: {
    APIEndPoint: REACT_APP_API_END_POINT,
    APIPort: REACT_APP_API_PORT,
    APILabel: REACT_APP_API_LABEL,
    APIVersion: REACT_APP_API_VERSION,
    sslEnabled: REACT_APP_SSL_ENABLED,
    gaMeasurementID: REACT_APP_GA_MEASUREMENT_ID,
  },
};

module.exports = {config};
